import React from "react";
import { motion } from "framer-motion";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import moment from "moment";
import { ageCalculator } from "helpers/utils";
import { useLocation } from "react-router-dom";

const NestedPayerResponse = ({ row }) => {
  const {
    preauthorizationResponse,
    viewPreauthorizationInfo,
    preauthorizationRequest,
    preauthorizationEligibility,
    servicesErrorList,
    preauthorizationCancelResponse,
  } = useSelector((state) => state.preauthorization);

  const preauthResponse = viewPreauthorizationInfo?.payer_response;
  const preauthRequest = viewPreauthorizationInfo?.provider_request;

  const {
    claimResponseData,
    claimPreauthResponseData,
    claimCancelResponseData,
    eligibilityData,
    viewClaimInfo,
    claimRequestData,
  } = useSelector((state) => state.claim);

  const location = useLocation();

  console.log({ servicesErrorList });

  const preauthorizationClaimResponse =
    claimResponseData?.entry?.find(
      (e) => e.resource?.resourceType === "ClaimResponse"
    )?.resource ||
    preauthorizationResponse?.entry?.find(
      (e) => e.resource?.resourceType === "ClaimResponse"
    )?.resource ||
    preauthorizationResponse?.entry
      ?.find((item) => item?.resource?.resourceType === "Bundle")
      ?.resource?.entry?.find(
        (item) => item?.resource?.resourceType === "ClaimResponse"
      )?.resource ||
    claimResponseData?.entry
      ?.find((item) => item?.resource?.resourceType === "Bundle")
      ?.resource?.entry?.find(
        (item) => item?.resource?.resourceType === "ClaimResponse"
      )?.resource;

  console.log({ preauthorizationClaimResponse });

  const isTag = preauthorizationClaimResponse?.meta?.tag;
  const isCalim = location.pathname.includes("claim");

  const prescription =
    preauthorizationResponse?.use === "predetermination" ||
    claimResponseData?.use === "predetermination" ||
    preauthorizationClaimResponse?.use === "predetermination";

  const preauthorizationEligibilityRes =
    preauthorizationEligibility?.entry?.find(
      (e) => e.resource?.resourceType === "CoverageEligibilityResponse"
    )?.resource ||
    eligibilityData?.entry?.find(
      (e) => e.resource?.resourceType === "CoverageEligibilityResponse"
    )?.resource;

  const cliamPreauthorization =
    preauthorizationRequest?.entry?.find(
      (e) => e.resource?.resourceType === "Claim"
    )?.resource ||
    claimRequestData?.entry?.find((e) => e.resource?.resourceType === "Claim")
      ?.resource;

  const cliamPreauthorizationResponse =
    preauthorizationResponse?.entry?.find(
      (e) => e.resource?.resourceType === "ClaimResponse"
    )?.resource ||
    claimResponseData?.entry?.find(
      (e) => e.resource?.resourceType === "ClaimResponse"
    )?.resource;

  const isAdvanced = !!viewPreauthorizationInfo?.preauthadv_id;

  console.log({ isAdvanced });

  const advancedClaimResponse = preauthorizationResponse?.entry
    ?.find((item) => item?.resource?.resourceType === "Bundle")
    ?.resource?.entry?.find(
      (item) => item?.resource?.resourceType === "ClaimResponse"
    )?.resource;

  console.log({ advancedClaimResponse });

  const advancedPreauthPatient = Boolean(isAdvanced)
    ? preauthorizationResponse?.entry
      ?.find((item) => item?.resource?.resourceType === "Bundle")
      ?.resource?.entry?.find(
        (item) => item?.resource?.resourceType === "Patient"
      )?.resource
    : null;

  const advancedPreauthCoverage = preauthorizationResponse?.entry
    ?.find((item) => item?.resource?.resourceType === "Bundle")
    ?.resource?.entry?.find(
      (item) => item?.resource?.resourceType === "Coverage"
    )?.resource;

  const relatedClaimCode =
    cliamPreauthorization?.related?.[0]?.relationship?.coding?.[0]?.code;

  const relatedID =
    cliamPreauthorization?.related?.[0]?.claim?.identifier?.value;

  const claimPreauth = claimPreauthResponseData?.entry?.find(
    (item) => item?.resource?.resourceType === "ClaimResponse"
  )?.resource;

  const relatedDisplay = relation?.find(
    (item) => item?.rltdrlshp_code === relatedClaimCode
  )?.rltdrlshp_name;

  const getClassValue = (type) =>
    advancedPreauthCoverage?.class?.find(
      (c) => c.type?.coding?.[0]?.code === type
    )?.value || "";

  const getOccupationOrReligion = (type) => {
    const serviceEvent = advancedPreauthPatient?.extension?.find((ext) =>
      ext.url?.includes(type)
    );

    return serviceEvent?.valueCodeableConcept?.coding?.[0]?.code || null;
  };

  const { age } = ageCalculator(advancedPreauthPatient?.birthDate);

  const errorRemarkDetails =
    preauthorizationClaimResponse?.error
      ?.flatMap((error) =>
        error?.code?.coding?.map((coding) => {
          const valueString = coding?.extension?.find(
            (ext) =>
              ext?.url ===
              "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-error-expression"
          )?.valueString;

          const display = coding?.display;

          if (valueString && display) {
            return `${display} - ( ${valueString} )`;
          } else if (display) {
            return display;
          } else if (valueString) {
            return valueString;
          }

          return null;
        })
      )
      ?.filter(Boolean) || [];

  // Compute status value and style
  const getStatusInfo = () => {
    let statusValue = "";
    let statusStyle = { backgroundColor: "#f8f9fa", color: "#000" };

    // Determine status value from various sources
    if (row?.preauthsts || row?.claimsts) {
      statusValue = (row?.preauthsts || row?.claimsts || "").toLowerCase();
    } else if (viewClaimInfo?.claim_status) {
      statusValue = viewClaimInfo.claim_status.toLowerCase();
    } else if (viewPreauthorizationInfo?.preauth_status) {
      statusValue = viewPreauthorizationInfo.preauth_status.toLowerCase();
    } else if (cliamPreauthorizationResponse?.outcome) {
      statusValue = cliamPreauthorizationResponse.outcome.toLowerCase();
    } else {
      statusValue = "";
    }

    // Map status to corresponding styles
    const statusStyles = {
      error: {
        backgroundColor: "#fde6d8",
        color: "#ac5a2b",
        icon: "exclamation",
      },
      rejected: { backgroundColor: "#fee2e2", color: "#dc2626" },
      noresp: { backgroundColor: "#e5e7eb", color: "#374151" },
      approved: { backgroundColor: "#dcfce7", color: "#16a34a" },
      complete: { backgroundColor: "#dcfce7", color: "#16a34a" },
      cancelled: { backgroundColor: "#fce7f6", color: "#db2777" },
      pended: { backgroundColor: "#dbeafe", color: "#2563eb" },
      queued: { backgroundColor: "#fef9c3", color: "#ca8a04" },
      partial: { backgroundColor: "#cffafe", color: "#0891b2" },
      adjudication: { backgroundColor: "#ede9fe", color: "#7c3aed" },
      "not-required": { backgroundColor: "#e0f2fe", color: "#0284c7" },
      unknown: { backgroundColor: "#f8f9fa", color: "#000" }, // Fallback for unknown status
    };

    if (statusValue && statusStyles[statusValue]) {
      statusStyle = statusStyles[statusValue];
    }

    return { statusValue, statusStyle };
  };

  const { statusValue, statusStyle } = getStatusInfo();

  const advancedReason =
    advancedClaimResponse?.extension?.find((item) =>
      item?.url?.includes("extension-advancedAuth-reason")
    )?.valueCodeableConcept?.coding?.[0]?.display ||
    advancedClaimResponse?.extension?.find((item) =>
      item?.url?.includes("extension-advancedAuth-reason")
    )?.valueCodeableConcept?.coding?.[0]?.code ||
    "";

  const itemDetails = [
    {
      id: 1,
      title: "Response Date and Time",
      value:
        preauthorizationCancelResponse?.id || claimCancelResponseData
          ? moment(
            preauthorizationCancelResponse?.timestamp ||
            claimCancelResponseData
          ).format("DD-MM-YYYY , hh:mm:ss A")
          : moment(
            preauthorizationResponse?.timestamp ||
            claimResponseData?.timestamp
          ).format("DD-MM-YYYY , hh:mm:ss A"),
    },
    {
      id: 2,
      title: "PreAuth Reference Number",
      value:
        preauthorizationClaimResponse?.preAuthRef ||
        claimRequestData?.preAuthRef ||
        advancedClaimResponse?.preAuthRef ||
        "",
    },
    ...(isAdvanced
      ? [
        {
          id: 3,
          title: "Advanced",
          value: "Advanced Preauthorization",
        },
      ]
      : []),
    {
      id: 4,
      title: "Approval Identifier",
      value:
        preauthorizationClaimResponse?.request?.identifier?.value ||
        claimResponseData?.request?.identifier?.value ||
        advancedClaimResponse?.identifier?.[0]?.value ||
        "",
      advanced: true,
    },
    {
      id: 5,
      title: `${claimRequestData?.id ? "Claim" : "Pre-Authorization"} Type`,
      value: (() => {
        const code =
          claimResponseData?.type?.coding?.[0]?.code ||
          cliamPreauthorizationResponse?.type?.coding?.[0]?.code ||
          viewPreauthorizationInfo?.claim_typenme ||
          viewClaimInfo?.claim_typenme ||
          viewClaimInfo?.claim_type;

        if (code === "oral") {
          return "Dental";
        }

        return code || "";
      })(),
    },

    {
      id: 6,
      title: `${claimResponseData?.id ? "Claim" : "Preauthorization"} Sub Type`,
      value:
        viewClaimInfo?.preauth_subtype ||
        viewPreauthorizationInfo?.preauth_subtype ||
        subPreauthType?.find(
          (item) =>
            item?.claimsub_types_code ===
            cliamPreauthorization?.subType?.coding?.[0]?.code
        )?.claimsub_types_name ||
        "",
    },
    ...(isAdvanced
      ? [
        {
          id: 23,
          title: "Advanced Reason",
          value: advancedReason,
        },
      ]
      : []),
    ...(!isCalim
      ? [
        {
          id: 7,
          title: "Preauthorization ID",
          value: claimPreauth?.request?.identifier?.value || "",
        },
      ]
      : []),
    ...(relatedDisplay || relatedID
      ? [
        {
          id: 8,
          title: "Related",
          value: `${relatedDisplay || ""} - (${relatedID || ""})`,
        },
      ]
      : []),
    {
      id: 9,
      title: `${claimResponseData?.id ? "Claim" : "Pre-Authorization"} Status`,
      value: (
        <span
          className="d-inline-block rounded-pill px-2 py-1"
          style={{
            backgroundColor: statusStyle.backgroundColor,
            color: statusStyle.color,
            fontSize: "0.75rem",
            fontWeight: 500,
            border: "1px solid transparent",
            borderColor: "rgba(0,0,0,0.1)",
          }}
        >
          {statusValue}
        </span>
      ),
    },
    ...(preauthorizationRequest?.id
      ? [
        {
          id: 10,
          title: "Bundle Request ID",
          value: preauthorizationRequest?.id,
        },
      ]
      : []),
    ...(prescription
      ? [
        {
          title: "Prescription",
          value: prescription ? "Yes" : "No" || "",
        },
      ]
      : []),
    ...(preauthorizationEligibilityRes?.request?.identifier?.value
      ? [
        {
          id: 11,
          title: "Eligibility reference",
          value: preauthorizationEligibilityRes?.request?.identifier?.value,
        },
      ]
      : []),
    ...(!isCalim
      ? [
        {
          id: 12,
          title: "PreAuth From",
          value: (() => {
            let startDate = "";

            if (isAdvanced) {
              startDate = advancedClaimResponse?.preAuthPeriod?.start;
            } else {
              startDate =
                preauthorizationClaimResponse?.preAuthPeriod?.start ||
                claimResponseData?.preAuthPeriod?.start;
            }

            return startDate
              ? moment.utc(startDate).format("DD-MM-YYYY")
              : "";
          })(),
        },
      ]
      : []),
  ];

  const patientDetails = [
    {
      id: 1,
      title: "Identity Type",
      value:
        identityType[
        `${advancedPreauthPatient?.identifier?.[0]?.type?.coding?.[0]?.code}`
        ],
    },
    {
      id: 2,
      title: "Identity No",
      value: advancedPreauthPatient?.identifier?.[0]?.value || "-",
    },
    {
      id: 3,
      title: "Membership No",
      value: advancedPreauthCoverage?.identifier?.[0]?.value || "-",
    },
    { id: 4, title: "Policy No", value: getClassValue("plan") },
    {
      id: 5,
      title: "Medical Record Number",
      value:
        advancedPreauthPatient?.identifier?.find((item) =>
          item?.system?.includes("medicalrecordnumber")
        )?.value || "",
    },
    { id: 6, title: "Class Name", value: getClassValue("group") },
    { id: 7, title: "Gender", value: advancedPreauthPatient?.gender },
    {
      id: 8,
      title: "Relation",
      value: advancedPreauthCoverage?.relationship?.coding?.[0]?.display || "",
    },
    {
      id: 9,
      title: "Martial Status",
      value:
        maritalStatusMap[
        advancedPreauthPatient?.maritalStatus?.coding?.[0]?.code
        ] || "-",
    },
    {
      id: 10,
      title: "Occupation",
      value:
        occupation?.find(
          (item) =>
            item?.occup_code === getOccupationOrReligion("extension-occupation")
        )?.occup_disply || "",
    },
    {
      id: 11,
      title: "Religion",
      value:
        religion?.find(
          (item) =>
            item?.religion_code ===
            getOccupationOrReligion("extension-patient-religion")
        )?.religion_name || "",
    },
  ];

  return (
    <>
      <motion.div
        style={{ border: "2px solid #d9f8eb" }}
        className="rounded p-3 position-relative mt-3"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 50 }}
        transition={{ duration: 0.5 }}
      >
        <div className="position-absolute top-0 start-40 translate-middle-y px-2">
          <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
            <span className="fs-11">Payer response</span>
          </span>
        </div>

        <Row className="mt-1">
          {itemDetails?.map((item) => (
            <Col xs={6} md={4} xl={3} className="mb-3" key={item.id}>
              <Item title={item?.title} value={item?.value} />
            </Col>
          ))}

          {!isCalim && (
            <Col xs={6} md={4} xl={3} className="mb-3">
              <Item
                title={"PreAuth To"}
                value={(() => {
                  let endDate = "";

                  if (isAdvanced) {
                    endDate = advancedClaimResponse?.preAuthPeriod?.end;
                  } else {
                    endDate =
                      preauthorizationClaimResponse?.preAuthPeriod?.end ||
                      claimResponseData?.preAuthPeriod?.end;
                  }

                  return endDate
                    ? moment.utc(endDate).format("DD-MM-YYYY")
                    : "";
                })()}
              />
            </Col>
          )}
          <Col xs={12} className="mb-3">
            <Item
              remark={true}
              title={"Remark"}
              value={
                <>
                  <ul className="mb-0 list-unstyled">
                    {errorRemarkDetails.map((item, index) => (
                      <li key={index}>
                        <span className="fw-bold me-2 ">
                          {isTag ? "(NPHIES)" : "(PAYER)"}
                        </span>
                        {item}
                      </li>
                    ))}
                  </ul>

                  <div className="d-flex flex-column gap-1">
                    {preauthorizationClaimResponse?.disposition && (
                      <div className="fw-medium">
                        <span className="fw-medium me-2">
                          {"Disposition"}
                        </span>{" "}
                        {preauthorizationClaimResponse.disposition}
                      </div>
                    )}
                    {preauthorizationClaimResponse?.processNote?.map(
                      (note, index) => (
                        <div key={index} className="fw-medium">
                          <span className="fw-medium me-2">
                            {`(ProcessNote) - `}
                          </span>
                          {note.text} {note.number && `(Code: ${note.number})`}
                        </div>
                      )
                    )}

                    {servicesErrorList?.length > 0 &&
                      servicesErrorList?.map((item, idx) => (
                        <div key={idx} className="fw-medium">
                          <span className="fw-medium me-2">
                            {`(adjudication) - `}
                          </span>
                          {item}
                        </div>
                      ))}
                  </div>
                </>
              }
            />
          </Col>
        </Row>
      </motion.div>
      {viewPreauthorizationInfo?.preauthadv_id && (
        <motion.div
          style={{ border: "2px solid #d9f8eb" }}
          className="rounded p-3 position-relative mt-3 mb-3"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ duration: 0.5 }}
        >
          <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
            <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
              <span className="fs-11">Beneficiary Details</span>
            </span>
          </div>
          <Row>
            <Col xs={12}>
              <Row>
                <Col xs={4} md={1}>
                  <div className="position-relative d-inline-block">
                    <img
                      src="/test-img.png"
                      alt="Patient"
                      className="img-fluid rounded-circle border"
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "cover",
                        border: "3px solid #2c7be5",
                      }}
                    />
                  </div>
                </Col>
                <Col xs={8} md={11}>
                  <div className="d-flex flex-column">
                    <span className="fs-10 fw-bold ">
                      {advancedPreauthPatient?.name?.[0]?.text}
                    </span>
                    <span className="fs-10 text-600 fw-bold text-capitalize ">
                      {age?.years} Years - {advancedPreauthPatient?.gender}
                    </span>
                  </div>
                </Col>
              </Row>
              <hr />
              <Row className="mt-1">
                {patientDetails?.map((item) => (
                  <Col xs={6} md={4} xl={3} className="mb-3" key={item.id}>
                    <Item title={item?.title} value={item?.value} />
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </motion.div>
      )}
    </>
  );
};

export default NestedPayerResponse;

export const Item = ({ title, value, remark, advanced = false }) => {
  return (
    <div className="d-flex flex-column gap-1 w-100">
      <div className="fs-10 fw-bold">{title}</div>
      <div
        className={`${remark ? "text-danger" : "text-600"
          } fw-normal text-capitalize ${advanced ? "fs-9" : "fs-10"}`}
      >
        {value}
      </div>
    </div>
  );
};

export const relation = [
  {
    rltdrlshp_code: "prior",
    rltdrlshp_name: "Prior Claim",
  },
  {
    rltdrlshp_code: "associated",
    rltdrlshp_name: "Associated Claim",
  },
  {
    rltdrlshp_code: "appealing",
    rltdrlshp_name: "Appealing",
  },
  {
    rltdrlshp_code: "extend",
    rltdrlshp_name: "Authorization to extend",
  },
];

const subPreauthType = [
  {
    claimsub_types_id: 1,
    claimsub_types_code: "ip",
    claimsub_types_name: "InPatient",
    claimsub_types_dflt: 0,
  },
  {
    claimsub_types_id: 2,
    claimsub_types_code: "op",
    claimsub_types_name: "OutPatient",
    claimsub_types_dflt: 1,
  },
  {
    claimsub_types_id: 3,
    claimsub_types_code: "emr",
    claimsub_types_name: "Emergency",
    claimsub_types_dflt: 0,
  },
];

const maritalStatusMap = {
  M: "Married",
  S: "Single",
  D: "Divorced",
  W: "Widowed",
  L: "Legally Separated",
  U: "Unmarried",
};

const identityType = {
  PRC: "Iqama",
  PPN: "Passport No.",
  NI: "National ID",
  VP: "Visa No.",
  MR: "Medical record Number ",
  BN: "Border Number",
  DP: "Displaced person",
};

const religion = [
  {
    religion_code: "0",
    religion_name: "Other",
  },
  {
    religion_code: "1",
    religion_name: "Muslim",
  },
  {
    religion_code: "2",
    religion_name: "Christian",
  },
  {
    religion_code: "3",
    religion_name: "Judaism",
  },
  {
    religion_code: "4",
    religion_name: "Buddhism",
  },
  {
    religion_code: "5",
    religion_name: "Zoroastrian",
  },
  {
    religion_code: "7",
    religion_name: "Hinduism",
  },
  {
    religion_code: "8",
    religion_name: "Sikh",
  },
  {
    religion_code: "9",
    religion_name: "Without",
  },
  {
    religion_code: "98",
    religion_name: "Not available",
  },
  {
    religion_code: "99",
    religion_name: "Not Mentioned",
  },
];

const occupation = [
  {
    occup_code: "administration",
    occup_disply: "Administration",
  },
  {
    occup_code: "agriculture",
    occup_disply: "Agriculture",
  },
  {
    occup_code: "business",
    occup_disply: "Business",
  },
  {
    occup_code: "education",
    occup_disply: "Education",
  },
  {
    occup_code: "housewife",
    occup_disply: "Housewife",
  },
  {
    occup_code: "marine",
    occup_disply: "Marine",
  },
  {
    occup_code: "medical field",
    occup_disply: "Medical Field",
  },
  {
    occup_code: "military",
    occup_disply: "Military",
  },
  {
    occup_code: "skilled worker",
    occup_disply: "Skilled Worker",
  },
  {
    occup_code: "student",
    occup_disply: "Student",
  },
  {
    occup_code: "oil industries",
    occup_disply: "Oil Industries",
  },
  {
    occup_code: "unemployed",
    occup_disply: "Unemployed",
  },
  {
    occup_code: "others",
    occup_disply: "Others",
  },
  {
    occup_code: "unknown",
    occup_disply: "Unknown",
  },
];
